var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.910051 1.21004C1.45678 0.663304 2.34322 0.663304 2.88995 1.21004L7.5 5.82009L12.1101 1.21004C12.6568 0.663304 13.5432 0.663304 14.0899 1.21004C14.6367 1.75677 14.6367 2.6432 14.0899 3.18994L8.48995 8.78994C7.94322 9.33667 7.05678 9.33667 6.51005 8.78994L0.910051 3.18994C0.363316 2.6432 0.363316 1.75677 0.910051 1.21004Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.c7a1638ca19bc92a81ab77b71c81cc44.svg";
export { ForwardRef as ReactComponent };